module.exports = __webpack_public_path__ + "img/zanzibar.3fa9821c.jpg";